import { useEffect, useMemo, useState } from "react";
import { api } from "../api";
import { Badge } from "../Badge";
import { formatDate, formatTime } from "../caregiver/CaregiverDashboard";

export default function PatientVisits() {
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    api.get("/patient/visits").then((r) => setVisits(r.data)).catch(() => setVisits([]));
  }, []);

  const { upcoming, past } = useMemo(() => {
    if (!visits) return { upcoming: [], past: [] };
    const today = new Date().toISOString().slice(0, 10);
    return {
      upcoming: visits.filter((v) => v.date >= today && v.status !== "Cancelled" && v.status !== "Completed").sort((a, b) => (a.date + a.start_time).localeCompare(b.date + b.start_time)),
      past: visits.filter((v) => !(v.date >= today && v.status !== "Cancelled" && v.status !== "Completed")),
    };
  }, [visits]);

  const VisitRow = ({ v }) => (
    <li data-testid={`visit-row-${v.id}`} className="flex items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white px-5 py-4">
      <div className="min-w-0">
        <p className="font-bold text-brand-navy">{formatDate(v.date)}</p>
        <p className="text-sm text-slate-500">{formatTime(v.start_time)} – {formatTime(v.end_time)} · {v.care_type} · {v.caregiver_name}</p>
      </div>
      <Badge kind="visit" value={v.status} />
    </li>
  );

  return (
    <div data-testid="patient-visits">
      <h1 className="font-display text-3xl md:text-4xl text-brand-navy">My Visits</h1>
      <p className="mt-2 text-[15px] text-slate-600">Your scheduled and completed care visits.</p>

      {visits === null ? (
        <p className="mt-8 text-slate-500 font-semibold">Loading visits…</p>
      ) : (
        <>
          <h2 className="mt-8 font-display text-xl text-brand-navy">Upcoming</h2>
          <ul className="mt-3 space-y-3">
            {upcoming.length === 0 && <li className="rounded-2xl border border-slate-200 bg-white p-6 text-slate-500">No upcoming visits scheduled.</li>}
            {upcoming.map((v) => <VisitRow key={v.id} v={v} />)}
          </ul>
          <h2 className="mt-8 font-display text-xl text-brand-navy">Past & Cancelled</h2>
          <ul className="mt-3 space-y-3">
            {past.length === 0 && <li className="rounded-2xl border border-slate-200 bg-white p-6 text-slate-500">No past visits yet.</li>}
            {past.map((v) => <VisitRow key={v.id} v={v} />)}
          </ul>
        </>
      )}
    </div>
  );
}
